import { Tabs } from 'bold-ui'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { PageHeaderSection } from 'components/PageHeaderSection'
import { PecSwitch, PrivateRoute, TabLink } from 'components/route'
import React from 'react'
import { Redirect, useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions'

import { CredenciaisIntegracaoBox } from './credenciais-integracao/CredenciaisIntegracaoBox'

const TITLE = 'Configurações de integração'

export function IntegracaoConfiguracaoRootView() {
  const match = useRouteMatch()
  return (
    <>
      <Breadcrumb title={TITLE} />
      <PageHeaderSection title={TITLE}>
        <Tabs>
          <TabLink to={`${match.url}/credencial`}>Credenciais de integração</TabLink>
        </Tabs>
      </PageHeaderSection>

      <PageContent>
        <PecSwitch>
          <Redirect exact from={`${match.url}`} to={`${match.url}/credencial`} />
          <PrivateRoute
            exact
            path={`${match.url}/credencial`}
            component={CredenciaisIntegracaoBox}
            permission={Permissions.administracaoGeralDaInstalacao}
          />
        </PecSwitch>
      </PageContent>
    </>
  )
}
